import {
  timestampToDateOnly,
  toNoonTimestamp,
} from "../providers/commons/financeSchedule";

/** Number from a form value, null when empty */
export const toNullableNumber = (value: unknown): number | null =>
  value === "" || value == null || Number.isNaN(Number(value))
    ? null
    : Number(value);

/** Empty strings from text inputs are stored as null */
export const toNullableText = (value: unknown): string | null =>
  typeof value === "string" && value.trim() !== "" ? value.trim() : null;

/**
 * Timestamp to store for a day picked in a date input: the previous timestamp
 * when the day did not change (keeps its exact time), local noon otherwise.
 */
export const dayToTimestamp = (
  day: unknown,
  previous?: string | null,
): string | null => {
  if (typeof day !== "string" || day === "") return null;
  if (previous && timestampToDateOnly(previous) === day) return previous;
  return toNoonTimestamp(day);
};

/** Error key when a date input value is not a `YYYY-MM-DD` day */
export const isDay = (value: unknown): value is string =>
  typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value);
